import React, {
  Component
} from 'react';
import {
  Button,
  Divider,
  Form,
  Message
} from 'semantic-ui-react';

const roles = [
  {
    key: 0,
    text: 'Administrador',
    value: 'admin'
  },
  {
    key: 1,
    text: 'Supervisor',
    value: 'supervisor'
  },
  {
    key: 2,
    text: 'Operador',
    value: 'operator'
  },
  {
    key: 3,
    text: 'Investigador',
    value: 'inquirer'
  }
];

const UsersForm = (props) =>
  <Form onSubmit={props.onSubmit} loading={props.submitting}>
    <Form.Group>
      <Form.Input
        label="Email" width="10" type="email"
        value={props.values.email} onChange={props.createInputHandler('email')} />
      <Form.Input
        label="Nombre" width="6"
        value={props.values.name} onChange={props.createInputHandler('name')} />
    </Form.Group>
    <Form.Group>
      <Form.Input
        label="Clave" width="6" type="password"
        value={props.values.password} onChange={props.createInputHandler('password')} />
      <Form.Input
        label="Nivel de Acceso" width="4" type="number" min="0"
        value={props.values.clearance} onChange={props.createInputHandler('clearance')} />
    </Form.Group>
    <Form.Group>
      <Form.Select
        label="Roles" width="16" multiple options={roles}
        value={props.values.roles} onChange={props.createInputHandler('roles', 'select')} />
    </Form.Group>
    {
      props.error &&
        <Message negative attached>
          <Message.Header>Error {props.error.code}!</Message.Header>
          <p>{props.error.message}</p>
        </Message>
    }
    <Divider />
    <Button basic negative type="button" content="Cancelar" onClick={props.onDismiss} />
    <Button positive type="submit" floated="right" content="Aceptar" onClick={props.onSubmit} />
  </Form>;

export default UsersForm;


// WEBPACK FOOTER //
// ./client/components/pages/system/UsersForm.js